<template>
  <div class="news-edit-container">
    <!-- 主体两栏布局 -->
    <div class="editor-layout">
      <!-- 左侧编辑区 -->
      <div class="editor-main">
        <el-card shadow="never" class="main-card">
          <!-- 标题 -->
          <div class="title-section">
            <el-input
              v-model="form.title"
              placeholder="请输入新闻标题（必填）"
              maxlength="100"
              show-word-limit
              class="title-input"
              :class="{ 'is-error': titleError }"
              @blur="validateTitle"
            />
            <p v-if="titleError" class="error-tip">{{ titleError }}</p>
          </div>

          <!-- 文章信息栏 -->
          <div class="meta-section">
            <div class="meta-item">
              <span class="meta-label">分类</span>
              <el-select v-model="form.category" placeholder="请选择" size="small">
                <el-option label="公司新闻" value="0" />
                <el-option label="行业资讯" value="1" />
                <el-option label="技术文章" value="2" />
              </el-select>
            </div>
            <div class="meta-item">
              <span class="meta-label">标签</span>
              <el-checkbox v-model="form.isHot" true-label="1" false-label="0" border size="small">热门新闻</el-checkbox>
              <el-checkbox v-model="form.isTech" true-label="1" false-label="0" border size="small" style="margin-left:8px">技术专栏</el-checkbox>
              <el-checkbox v-model="form.isTop" true-label="1" false-label="0" border size="small" style="margin-left:8px">焦点新闻</el-checkbox>
            </div>
          </div>

          <!-- 摘要 -->
          <div class="summary-section">
            <el-input
              v-model="form.summary"
              type="textarea"
              :rows="3"
              placeholder="请输入新闻摘要，用于列表展示（选填）"
              maxlength="500"
              show-word-limit
            />
          </div>

          <!-- 富文本编辑器 -->
          <div class="editor-section">
            <div class="section-label">新闻正文</div>
            <div class="editor-wrapper">
              <Toolbar
                class="editor-toolbar"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                mode="simple"
              />
              <Editor
                class="editor-body"
                v-model="form.content"
                :defaultConfig="editorConfig"
                mode="simple"
                @onCreated="onEditorCreated"
                @onChange="onEditorChange"
              />
            </div>
            <p v-if="contentError" class="error-tip">{{ contentError }}</p>
          </div>
        </el-card>
      </div>

      <!-- 右侧设置面板 -->
      <div class="editor-sidebar">
        <!-- 发布操作 -->
        <el-card shadow="never" class="sidebar-card">
          <div slot="header" class="card-header">
            <span>发布</span>
          </div>
          <div class="publish-actions">
            <el-button
              type="primary"
              @click="submitForm('publish')"
              :loading="submitting"
              class="btn-publish"
            >
              {{ isEdit ? '保存更新' : '立即发布' }}
            </el-button>
            <el-button
              plain
              @click="submitForm('draft')"
              :loading="savingDraft"
              class="btn-draft"
            >
              保存草稿
            </el-button>
          </div>
          <div class="publish-info">
            <div class="info-item" v-if="wordCount > 0">
              <span>字数：</span>
              <strong>{{ wordCount }}</strong>
            </div>
          </div>
        </el-card>

        <!-- 封面图片 -->
        <el-card shadow="never" class="sidebar-card">
          <div slot="header" class="card-header">
            <span>封面图片</span>
          </div>
          <el-upload
            class="cover-uploader"
            :action="uploadUrl"
            accept = ".jpg,.png"
            :show-file-list="false"
            :on-success="handleImageSuccess"
            :before-upload="beforeImageUpload"
            drag
          >
            <div class="cover-preview" v-if="form.image">
              <img :src="form.image" class="cover-image" />
              <div class="cover-mask">
                <i class="el-icon-edit"></i>
                <span>更换封面</span>
              </div>
            </div>
            <div class="cover-placeholder" v-else>
              <i class="el-icon-picture-outline-round"></i>
              <div class="cover-text">拖拽或点击上传封面</div>
              <div class="cover-tip">支持 JPG/PNG/GIF/WebP，≤10MB</div>
            </div>
          </el-upload>
        </el-card>

        <!-- 发布时间 -->
        <el-card shadow="never" class="sidebar-card">
          <div slot="header" class="card-header">
            <span>发布时间</span>
          </div>
          <el-date-picker
            v-model="form.publishTime"
            type="datetime"
            placeholder="选择发布时间（默认为当前时间）"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="publish-time-picker"
          />
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { newsAdd } from "@/api/news.js";

export default {
  name: 'newsAdd',
  components: { Editor, Toolbar },
  data() {
    return {
      isEdit: false,
      newsId: null,
      editor: null,
      contentError: '',
      titleError: '',
      form: {
        title: '',
        category: '0',
        summary: '',
        image: '',
        content: '',
        isHot: "0",
        isTech: "0",
        status: '0',
        publishTime: ''
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/file/upload/newsPicture',
      submitting: false,
      savingDraft: false,
      toolbarConfig: {
        excludeKeys: [
          'group-video',
          'fullScreen'
        ]
      },
      editorConfig: {
        placeholder: '请输入新闻正文内容...',
        MENU_CONF: {
          uploadImage: {
            server: process.env.VUE_APP_BASE_API + '/file/upload/newsPicture',
            fieldName: 'file',
            maxFileSize: 10 * 1024 * 1024,
            allowedFileTypes: ['image/*'],
            customInsert(res, insertFn) {
              if (res.code == 200) {
                insertFn(res.data.fullUrl, '', '');
              } else {
                this.$message.error(res.message || '图片上传失败');
              }
            }
          }
        }
      }
    }
  },
  computed: {
    wordCount() {
      if (!this.form.content) return 0;
      const text = this.form.content.replace(/<[^>]+>/g, '').replace(/\s+/g, '');
      return text.length;
    }
  },
  methods: {
    onEditorCreated(editor) {
      this.editor = Object.seal(editor);
    },
    onEditorChange(editor) {
      if (this.contentError && this.form.content && this.form.content.replace(/<[^>]+>/g, '').trim()) {
        this.contentError = '';
      }
    },
    validateTitle() {
      if (!this.form.title.trim()) {
        this.titleError = '请输入新闻标题';
      } else {
        this.titleError = '';
      }
    },
    handleImageSuccess(res) {
      if (res.code == 200) {
        this.form.image = res.data.fullUrl;
        this.$message.success('封面上传成功');
      } else {
        this.$message.error(res.message || '上传失败');
      }
    },
    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/');
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB');
        return false;
      }
      return true;
    },
    submitForm(action) {
      // 标题校验
      this.validateTitle();
      if (this.titleError) return;

      // 内容校验
      const textContent = this.form.content ? this.form.content.replace(/<[^>]+>/g, '').trim() : '';
      if (!textContent) {
        this.contentError = '请输入新闻正文内容';
        return;
      }
      this.contentError = '';

      const loadingKey = action === 'draft' ? 'savingDraft' : 'submitting';
      this[loadingKey] = true;

      const data = {
        ...this.form,
        status: action === 'draft' ? '0' : '1'
      };

      newsAdd(data).then(res => {
        if (res.data.code == 200) {
          this.$message.success(action === 'draft' ? '草稿已保存' : '发布成功');
          this.goBack();
        } else {
          this.$message.error(res.data.message || '操作失败');
        }
        this[loadingKey] = false;
      }).catch(() => {
        this.$message.error('操作失败');
        this[loadingKey] = false;
      });
    },
    goBack() {
      const view = this.$route;
      this.$store.dispatch('tagsView/delView', view).then(() => {
        this.$router.push('/news/newsList');
      });
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
  }
}
</script>

<style lang="less" scoped>
.news-edit-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;

  .editor-layout {
    display: flex;
    flex: 1;
    overflow: hidden;
    padding: 20px 24px;
    gap: 20px;
  }

  .editor-main {
    flex: 1;
    min-width: 0;
    overflow-y: auto;
  }

  .main-card {
    border-radius: 8px;

    ::v-deep .el-card__body {
      padding: 24px 30px;
    }
  }

  .title-section {
    margin-bottom: 20px;

    .title-input {
      ::v-deep input {
        font-size: 22px;
        font-weight: 600;
        border: none;
        border-bottom: 2px solid #e8e8e8;
        border-radius: 0;
        padding: 0 0 12px 0;
        height: auto;
        line-height: 1.4;

        &:focus {
          border-color: #409eff;
        }
      }

      &.is-error ::v-deep input {
        border-color: #f56c6c;
      }
    }

    .error-tip {
      color: #f56c6c;
      font-size: 12px;
      margin-top: 4px;
      margin-bottom: 0;
    }
  }

  .meta-section {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    padding: 16px 0;
    border-top: 1px dashed #e8e8e8;
    border-bottom: 1px dashed #e8e8e8;
    margin-bottom: 20px;

    .meta-item {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .meta-label {
      color: #909399;
      font-size: 13px;
      flex-shrink: 0;
    }

    .meta-input {
      width: 140px;
    }
  }

  .summary-section {
    margin-bottom: 24px;
  }

  .editor-section {
    .section-label {
      font-size: 14px;
      color: #303133;
      margin-bottom: 12px;
      font-weight: 500;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 14px;
        background: #409eff;
        border-radius: 2px;
        margin-right: 8px;
        vertical-align: -2px;
      }
    }

    .editor-wrapper {
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      overflow: hidden;

      &:focus-within {
        border-color: #409eff;
      }
    }

    .editor-toolbar {
      border-bottom: 1px solid #e8e8e8;
    }

    .editor-body {
      height: 500px;
      overflow-y: hidden;
    }

    .error-tip {
      color: #f56c6c;
      font-size: 12px;
      margin-top: 4px;
    }
  }

  .editor-sidebar {
    width: 320px;
    flex-shrink: 0;
    overflow-y: auto;

    .sidebar-card {
      margin-bottom: 16px;
      border-radius: 8px;

      .card-header {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
      }
    }

    .publish-actions {
      .btn-publish {
        width: 100%;
        margin-bottom: 10px;
        height: 40px;
        font-size: 15px;
      }

      .btn-draft {
        width: 100%;
        height: 36px;
      }
    }

    .publish-info {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;

      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        font-size: 13px;
        color: #666;

        &:last-child {
          margin-bottom: 0;
        }

        strong {
          color: #409eff;
        }
      }
    }

    .cover-uploader {
      ::v-deep .el-upload-dragger {
        width: 100%;
        height: auto;
        min-height: 180px;
        border-radius: 6px;
      }

      .cover-preview {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
        border-radius: 6px;

        .cover-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .cover-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
          opacity: 0;
          transition: opacity 0.3s;
          cursor: pointer;

          i { font-size: 28px; margin-bottom: 6px; }
          span { font-size: 14px; }
        }

        &:hover .cover-mask {
          opacity: 1;
        }
      }

      .cover-placeholder {
        padding: 40px 20px;
        text-align: center;

        i {
          font-size: 48px;
          color: #c0c4cc;
        }

        .cover-text {
          font-size: 14px;
          color: #606266;
          margin-top: 10px;
        }

        .cover-tip {
          font-size: 12px;
          color: #999;
          margin-top: 6px;
        }
      }
    }

    .publish-time-picker {
      width: 100%;
    }
  }
}

// 编辑器内部样式
::v-deep .w-e-text-container {
  background: #fff;

  .w-e-text-placeholder {
    font-style: normal;
    color: #c0c4cc;
  }

  h1, h2, h3 {
    border-bottom: none !important;
  }

  h2 {
    padding: 8px 0 8px 12px;
    border-left: 4px solid #409eff !important;
    background: #f5f7fa;
  }
}

::v-deep .w-e-toolbar {
  .w-e-bar-item button {
    &:hover {
      background: #f0f2f5;
    }
  }
}
</style>
